module.exports = __webpack_public_path__ + "static/media/linkIcon.04504ed0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/linkIcon.svg
// module id = ./src/common/images/linkIcon.svg
// module chunks = 1